<template>
    <div class="helper-controls" :class="{ 'helper-home': $route.meta.route == 'Home' }">
        <!-- <ProjectRoute
            :class="css.animation"
            class="absolute top-[-64px] right-[8px]"
            to="https://www.wjx.cn/vm/mCQ53UN.aspx"
            v-if="$i18n.locale == 'zh'">
            <img class="max-lg:h-[96px] object-cover" src="./src/images/img-active.webp" alt="" />
        </ProjectRoute> -->

        <template v-if="visible">
            <div>
                <wx-helper />
                <project-route
                    :to="{ name: 'BioVariantResult', query: { mode: 'codon' }, params: { id: $route.params.id } }"
                    target="_blank"
                    class="helper-control"
                    v-if="variant">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/f8c9f8a4-1414-49bb-aeb8-e5121cd016ee.webp" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/2d94850e-c97c-45db-9cfe-a07107990a16.webp" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("MutationViewer") }}</div>
                </project-route>
                <project-route
                    :to="{ name: 'BioSequenceResult', query: { mode: 'cDNA' }, params: { id: $route.params.id } }"
                    target="_blank"
                    class="helper-control"
                    v-if="sequence">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/6c0f8a65-c08b-4745-8a8a-b091aba16777.webp" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/f93c8e7d-f275-4607-b49a-5b74dc067fae.webp" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("SequenceViewer", 2) }}</div>
                </project-route>
                <Comparison />
                <project-route :to="{ name: 'Chatagent' }" target="_blank" class="helper-control">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/153c1553-3232-4b38-88d5-c2b88f504d8c.webp" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/84769e89-be9a-4068-9774-2623932f0093.webp" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("AnsweringAssistant") }}</div>
                </project-route>
                <project-route :to="{ name: 'Tutorials' }" target="_blank" class="helper-control">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/033c89db-a7ab-44be-9d69-f5cd3210afa4.webp" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/bec0de74-56d7-4435-8153-f662cce55d31.webp" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("Tutorials") }}</div>
                </project-route>
                <div class="helper-control" @click="triggerReturnTop">
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/1602101d-f6d8-4299-bbaa-3bd0972f73ac.webp" class="helper-icon" />
                    <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/15f3fb51-ae7b-4a5c-b766-59cf57e21b74.webp" class="helper-icon helper-icon-active" />
                    <div class="helper-context">{{ $t("ReturnTop") }}</div>
                </div>
            </div>
            <div class="helper-colose" @click="visible = false"><ui-icon name="close2" /></div>
        </template>
        <div v-else>
            <div class="helper-control" @click="visible = true">
                <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/4c7c30c8-101b-4440-8e05-439fb68f1d7e.webp" class="helper-icon" />
                <img src="https://rdgta.cdn.cyagen.com/rddc/pictures/a71c1fe2-b798-4d53-90e2-7cd2d88826eb.webp" class="helper-icon helper-icon-active" />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
//* 组件库
import { UiIcon } from "various-ui";
//* 私有组件
import Comparison from "./components/comparison/index.vue";
import WxHelper from "./components/wx/index.vue";
//* 样式
import css from "./style/index.module.less";

//* 路由
const route = useRoute();

//* 组件属性
const define = defineProps({ isTop: { type: Boolean, default: false } });
const emit = defineEmits(["returnTop"]);

//* 响应式变量
const variant = ref<boolean>(false);
const sequence = ref<boolean>(false);
const visible = ref<boolean>(true);

//* 回到顶部
const triggerReturnTop = () => {
    if (define.isTop) {
        emit("returnTop");
    } else {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }
};

//* 页面数据初始化
if (route.meta.route == "Gene" && route.params.id) {
    const data = await api.server("GeneDetails", "/api/gene", {
        data: { id: route.params.id },
        method: "POST",
    });
    variant.value = data.value.species == "9606";
    sequence.value = true;
}
</script>

<style lang="less" scoped>
@import url("./style/index.less");
</style>
